import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '#utilities/js/ea/globals.js'
import { hotkey } from '#utilities/js/hotkey/hotkey.js'

const handler = object(null, {
  task (
    element,
    event
  ) {
    preventDefault(event)
    const { ownerDocument } = element
    const checkbox = all('input[name="uid[]"]:checked', ownerDocument)

    if (checkbox.length !== 1) {
      return
    }

    const inputHidden = one(`input[name='act']`, ownerDocument)

    inputHidden.value = 'forward'
    globals.ea_form(inputHidden, '', null)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
